import { APP_CONFIG } from "./constants/constants";
import { APP_ENV } from "./api/network/endpoints";

const DYNAMIC_MSAL_CLIENT_ID_KEY = "MSAL_DYNAMIC_CLIENT_ID";
const DYNAMIC_MSAL_TENANT_ID_KEY = "MSAL_DYNAMIC_TENANT_ID";

const getStoredDynamicMsalValue = (key) => {
  if (typeof window === "undefined") return "";
  try {
    return localStorage.getItem(key) || "";
  } catch {
    return "";
  }
};

export const setDynamicMsalAuthConfig = ({ clientId, tenantId }) => {
  if (typeof window === "undefined") return;
  try {
    if (clientId) {
      localStorage.setItem(DYNAMIC_MSAL_CLIENT_ID_KEY, clientId);
    }
    if (tenantId) {
      localStorage.setItem(DYNAMIC_MSAL_TENANT_ID_KEY, tenantId);
    }
  } catch {
    // no-op
  }
};

const getAbsoluteAzureUri = (uri) => {
  if (/^https?:\/\//i.test(uri)) {
    return uri;
  }

  if (typeof window === "undefined") {
    return uri;
  }

  const appOrigin =
    APP_ENV === "be-local" ? "http://localhost:8000" : window.location.origin;

  return new URL(uri, appOrigin).toString();
};

export const getMsalConfig = ({ clientId, tenantId } = {}) => {
  const effectiveClientId =
    clientId ||
    getStoredDynamicMsalValue(DYNAMIC_MSAL_CLIENT_ID_KEY) ||
    "";
  const effectiveTenantId =
    tenantId ||
    getStoredDynamicMsalValue(DYNAMIC_MSAL_TENANT_ID_KEY) ||
    "";

  return {
    auth: {
      clientId: effectiveClientId,
      authority: `${APP_CONFIG.AZURE_AD.AUTHORITY_PREFIX}${effectiveTenantId}`, // https://login.microsoftonline.com/{tenantId}
      redirectUri: getAbsoluteAzureUri(APP_CONFIG.AZURE_AD.REDIRECT_URI),
      postLogoutRedirectUri: getAbsoluteAzureUri(APP_CONFIG.AZURE_AD.LOGOUT),
    },
    cache: {
      cacheLocation: "localStorage", // sessionStorage | localStorage
      storeAuthStateInCookie: false,
    },
  };
};

export const msalConfig = getMsalConfig();

export const msalLoginRequestParams = {
  scopes: ["openid", "profile", "email", "User.Read"]
};